export default "__VITE_ASSET__OIzSTc2H__"